export default "__VITE_ASSET__CRgdL31c__"